module.exports = {
	"name": "proj4",
	"version": "2.4.3",
	"description": "Proj4js is a JavaScript library to transform point coordinates from one coordinate system to another, including datum transformations.",
	"main": "dist/proj4-src.js",
	"module": "lib/index.js",
	"directories": {
		"test": "test",
		"doc": "docs"
	},
	"scripts": {
		"build": "grunt",
		"build:tmerc": "grunt build:tmerc",
		"test": "npm run build && istanbul test _mocha test/test.js"
	},
	"repository": {
		"type": "git",
		"url": "git://github.com/proj4js/proj4js.git"
	},
	"author": "",
	"license": "MIT",
	"devDependencies": {
		"grunt-cli": "~0.1.13",
		"grunt": "~0.4.2",
		"grunt-contrib-connect": "~0.6.0",
		"grunt-contrib-jshint": "~1.1.0",
		"chai": "~1.8.1",
		"mocha": "~1.17.1",
		"grunt-mocha-phantomjs": "~0.4.0",
		"rollup": "^0.41.4",
		"rollup-plugin-json": "^2.0.1",
		"rollup-plugin-node-resolve": "^2.0.0",
		"grunt-rollup": "^1.0.1",
		"grunt-contrib-uglify": "~0.11.1",
		"curl": "git://github.com/cujojs/curl.git",
		"istanbul": "~0.2.4",
		"tin": "~0.4.0"
	},
	"dependencies": {
		"mgrs": "1.0.0",
		"wkt-parser": "^1.1.3"
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/proj4/package.json
// module id = 190
// module chunks = 0 1